export default __webpack_public_path__ + "static/media/madame_detail9.f9c80983.jpg";